import React, { useState } from 'react';
import BookList from './BookList';
import UserList from './UserList';
import CheckoutForm from './CheckoutForm';
import AdminManagement from './AdminManagement';
import ImportData from './ImportData';

function Dashboard({ onLogout }) {
  const [activeTab, setActiveTab] = useState('books');

  const tabStyle = (tab) => ({
    padding: '10px 20px',
    margin: '0 5px',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    backgroundColor: activeTab === tab ? '#007bff' : '#f8f9fa',
    color: activeTab === tab ? 'white' : '#333'
  });

  return (
    <div>
      <header style={{
        backgroundColor: 'white',
        padding: '20px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        marginBottom: '20px'
      }}>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          maxWidth: '1200px',
          margin: '0 auto'
        }}>
          <h1 style={{margin: 0, color: '#333'}}>Library Management</h1>
          <button
            onClick={onLogout}
            style={{
              padding: '8px 16px',
              backgroundColor: '#dc3545',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Logout
          </button>
        </div>
      </header>

      <div style={{maxWidth: '1200px', margin: '0 auto', padding: '0 20px'}}>
        <div style={{marginBottom: '20px'}}>
          <button onClick={() => setActiveTab('books')} style={tabStyle('books')}>
            Books
          </button>
          <button onClick={() => setActiveTab('users')} style={tabStyle('users')}>
            Users
          </button>
          <button onClick={() => setActiveTab('checkout')} style={tabStyle('checkout')}>
            Check Out/In
          </button>
          <button onClick={() => setActiveTab('admins')} style={tabStyle('admins')}>
            Administrators
          </button>
          <button onClick={() => setActiveTab('import')} style={tabStyle('import')}>
            Import Data
          </button>
        </div>

        <div style={{
          backgroundColor: 'white',
          padding: '20px',
          borderRadius: '8px',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
        }}>
          {activeTab === 'books' && <BookList />}
          {activeTab === 'users' && <UserList />}
          {activeTab === 'checkout' && <CheckoutForm />}
          {activeTab === 'admins' && <AdminManagement />}
          {activeTab === 'import' && <ImportData />}
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
